module.exports = __webpack_public_path__ + "static/media/vata.1e52684e.jpg";